import React from 'react';
import { EditItemProps } from '../../../../toolympus/api/useNewItem';
import { LoadingIndicator, SimpleDialog } from '../../../../toolympus/components/primitives';
import { Typography } from '@mui/material';
import { HideOrUnhide } from '../data/useManageOrgStructure';

interface HideOrUnhideDialogProps {
  data: EditItemProps<HideOrUnhide>;
}

export const HideOrUnhideStructureNodeDialog: React.FC<HideOrUnhideDialogProps> = ({ data: controller }) => {
  const { dialog, item, save, isLoading } = controller;

  // Don't render the content if there's no active item
  if (!item) return null;

  // Determine the display name based on entity kind
  const displayName = item.kind === 'department'
    ? item.item.title
    : `${item.item.first_name || ''} ${item.item.last_name || ''}`.trim();

  const isHiding = item.operation === 'hide';
  const entityLabel = item.kind === 'department' ? 'отдел' : 'сотрудника';

  const title = isHiding 
    ? `Скрыть ${entityLabel}?` 
    : `Восстановить ${entityLabel}?`;

  const description = isHiding
    ? `Вы уверены, что хотите скрыть ${entityLabel} "${displayName}" из структуры? Он больше не будет отображаться в общих списках.`
    : `Вы уверены, что хотите восстановить ${entityLabel} "${displayName}"? Он снова появится в организационной структуре.`;

  const confirmText = isHiding ? 'Скрыть' : 'Восстановить';

  return (
    <SimpleDialog
      {...dialog}
      dialogTitle={title}
      saveLabel={confirmText}
      save={save}
      noFullscreen
      simpleExtraActions={<>
        {isLoading && <LoadingIndicator />}
      </>}
    >
      <Typography>{description}</Typography>
    </SimpleDialog>
  );
};